import {io, Socket} from "socket.io-client";

let socket: Socket | null = null;

export const getSocket = (user?: any) => {
  if (user && !socket) {
    socket = io(process.env.REACT_APP_HOST_API || '', {
      reconnectionAttempts: Infinity, // Keep trying to reconnect indefinitely
      reconnectionDelay: 5000,        // Wait 5 seconds between reconnection attempts
      auth: {
        sessionId: user.sessionId,
      },
      transports: ['websocket'],
      withCredentials: true,
    });

    socket.on('connect_error', (error) => {
      if (error.message === "Session ID unknown") {
        socket?.disconnect();
        setTimeout(() => {
          socket?.connect(); // Reconnect to get a new session ID
        }, 1000);
      }
    });
  }

  return socket;
}
